import axios from '@/mod/axiosMod';

export default {
  /**
   * 获取用户账号类型
   * @returns {*}
   * {
   *   "data": {
   *      "accountType":1,//0 普通商家 1 点评商家 2 第三方
   *   },
   *   "respCode": 0,//0成功，其他失败
   *   "respMsg": "请求成功"
   * }
   */
  getAccountType() {
    return axios.post('/api/v1/merchant-account/account_type');
  },
  /**
   * 是否屏蔽首页里 我的账单、我的收益、活动信息
   */
  getHideInfo() {
    return axios.post('/shepherd/api/cdb/bill/hide');
  },
  /**
   * 商家提权收益
   */
  getPoiEarn(poiId, needDecode) {
    const params = needDecode ? { key: poiId } : { poiId };
    const url = needDecode ? '/api/bill/v2/dc/rights/earnings/query' : '/api/bill/v2/rights/earnings/query';
    return axios.get(url, { params });
  },
  /**
   * 获取资质类型
   */
  getQualificationType() {
    return axios.post('/api/bill/v2/judgeQualificationType');
  },
  /**
   * 获取开店宝主账号信息
   */
  getAdminAccount() {
    return axios.post('/shepherd/api/cdb/login');
  },
};
